module.exports = __webpack_public_path__ + "bodysite-logo.20da97.svg";